export const LocalFeatureFlags = {
  ai_assistant: true,
  catalog: true,
  collection_photoshoot: true,
  decorator_profile: true,
  lifestyle_image: true,
  local_settings: true,
  org_management: true,
  product_2d: true,
  textura_viewer_setup: false,
  use_stitches_decals: true,
  brand_logos: false,
  api_keys_dashboard: true,
  api_payload_export: true,
  logo_underbase: true,
  hide_vector_color: true,
  collection_techpack: true,
};
